import './index.css';

// import { StrictMode } from 'react';
import i18n from 'i18next';
import HttpApi from 'i18next-http-backend';
import ReactDOM from 'react-dom/client';
import { initReactI18next } from 'react-i18next';
import { MutationCache, QueryCache, QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { CssBaseline } from '@mui/material';
import { registerSW } from 'virtual:pwa-register';

import App from './App.tsx';

registerSW({ immediate: true });

// https://vite.dev/guide/build#load-error-handling
window.addEventListener('vite:preloadError', (event) => {
  event.preventDefault();
  window.location.reload();
});

const params = new URLSearchParams(document.location.search);
const l = params.get('l');

// TODO meg a browser language-et is hasznalhatnank
// TODO miert 'hu' ha nincs mas es 'en' a default ?
const language = l || localStorage.getItem('language') || 'hu';
const defaultLanguage = 'hu';
const buildNumber = BUILD_NUMBER;

i18n
  // FIXME .use(LanguageDetector)
  .use(HttpApi)
  .use(initReactI18next)
  .init({
    lng: language,
    load: 'languageOnly',
    backend: {
      loadPath: `/i18n/{{lng}}.json?v=${buildNumber}`, // must be relative so it works with base url
    },
    fallbackLng: defaultLanguage,
    interpolation: {
      escapeValue: true,
    },
  });

const queryClient = new QueryClient({
  queryCache: new QueryCache({
    onError: (_error, _query) => {
      console.debug(_error, _query);
    },
  }),
  mutationCache: new MutationCache({
    onError: (_error, _variables, _context, _mutation) => {
      console.debug(_error, _variables, _context, _mutation);
    },
  }),
});

const theme = createTheme({
  cssVariables: true,
  colorSchemes: { light: true, dark: false },
  typography: {
    allVariants: {
      fontFamily: "'Exo 2'",
    },
  },
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  // <StrictMode>
  <QueryClientProvider client={queryClient}>
    <ThemeProvider theme={theme}>
      <CssBaseline enableColorScheme />
      <App />
    </ThemeProvider>
  </QueryClientProvider>
  // </StrictMode>
);
